
import {PropType} from 'vue';
import {HasNameInterface} from 'modules/spravochnik/dt-front-page-generator/src/Entity/HasNameInterface';
import {SearchResultInterface, SearchServiceInterface} from 'modules/spravochnik/dt-front-page-generator/src/Search';
import searchTextHL from 'search-text-highlight';
import {Category} from 'modules/spravochnik/dt-front-page-generator/src/Entity/Category';
import {Page} from 'modules/spravochnik/dt-front-page-generator/src/Entity/Page';

export default {
    props: {
        objects: {
            type: Array as PropType<Array<HasNameInterface>>
        },
        service: {
            type: Object as PropType<SearchServiceInterface<HasNameInterface>>,
            require: true,
        },
        placeholder: {
            type: String
        },
    },
    emits: ['openSearch'],
    methods: {
        onEnter() {
            if (this.searchResult.length === 1) {
                const result = this.searchResult[0];
                this.onRouteToEntity(result.entity);
            }
        },
        textToHighlightHtml(entity: HasNameInterface): string {
            return searchTextHL.highlight(entity.name.toString(), this.searchText);
        },
        getService(): SearchServiceInterface<HasNameInterface>  {
            return this.service;
        },
        onClearSearch(): void {
            this.searchText = '';
            this.$refs.search.focus();
        },
        search(): any {
            this.$emit('openSearch');
            this.resultValueCategory = [];
            this.resultValuePage = [];
            this.searchResult = this.getService().searchByName(this.objects, this.searchText);
        },
        onClickAway(event): void {
            if (event.isTrusted) {
                this.visibleResult = false;
            }
        },
        onRouteToEntity(entity: Category|Page) {
            this.$router.push(entity.getUrl());
        }
    },
    watch: {
        searchText(): void {
            if (this.searchText.length > 0) {
                this.visibleResult = true;
                this.search();
            } else {
                this.visibleResult = false;
            }
        },
        searchResult(): void {
            this.visibleResult = true;

            for (const item of this.searchResult) {
                if (item.entity instanceof Page) {
                    this.resultValuePage.push(item);
                }

                if (item.entity instanceof Category) {
                    this.resultValueCategory.push(item);
                }
            }
        }
    },
    data() {
        return {
            active: null,
            visibleResult: false,
            searchText: '',
            searchResult: [] as Array<SearchResultInterface>,
            resultValuePage: [] as Array<SearchResultInterface<Page>>,
            resultValueCategory: [] as Array<SearchResultInterface<Category>>,
        };
    }
};
